import { Avatar } from '@amore/ui/components/avatar'
import { Link } from '@tanstack/react-router'
import { UserRound } from 'lucide-react'
import { initials } from '@/lib/format'

export function CeremonyPersonIdentity({
  name,
  to,
  empty = 'Zatím nevybraný',
  compact = false,
  illustration,
  label,
}: {
  name?: string
  to?: string
  empty?: string
  compact?: boolean
  illustration?: string
  label?: string
}) {
  return (
    <div className="flex min-w-0 items-center gap-3">
      {illustration ? (
        <img
          src={illustration}
          alt=""
          width={112}
          height={120}
          className="size-16 shrink-0 rounded-full bg-panel-accent object-contain p-1"
        />
      ) : (
        <Avatar
          alt=""
          size={compact ? 'sm' : 'md'}
          fallback={
            name ? (
              initials(name.replace('Mgr. ', ''))
            ) : (
              <UserRound className="size-4" aria-hidden="true" />
            )
          }
        />
      )}
      <div className="min-w-0">
        {label ? <p className="mb-1 text-xs text-muted-foreground">{label}</p> : null}
        {name ? (
          to ? (
            <Link
              to={to}
              className="min-w-0 break-words text-sm font-semibold text-action underline-offset-4 hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
            >
              {name}
            </Link>
          ) : (
            <span className="min-w-0 break-words text-sm font-semibold">{name}</span>
          )
        ) : (
          <span className="text-sm text-muted-foreground">{empty}</span>
        )}
      </div>
    </div>
  )
}
